import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  width: 100%;
`

export const MainContent = styled.main`
  width: 100%;
  margin: 40px 80px;
`
